import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './css/style.css'; // ← здесь стили со шрифтами
import './css/design-system.css'; // ← новые токены v2, анимации, утилиты
import { setupAxios } from './API/axiosSetup';

// Подключаем глобальные перехватчики axios ДО первого запроса —
// иначе ранние вызовы из AuthProvider могут проскочить без 401-handling.
setupAxios();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);

